<template>
    <span class='material-symbols-rounded select-none flex items-center justify-center' :class='colorClass'>
      keyboard_arrow_up
    </span>
</template>

<script setup lang='ts'>
interface Props {
  colorClass?: string
}

withDefaults(defineProps<Props>(), {
  colorClass: 'text-grey-3' // default
})
</script>
